<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  catalog: { type: Object, default: () => ({}) },
  value: { type: Object, required: true },
});

const emit = defineEmits(['update:value']);
const { t } = useI18n();

const update = sellers => emit('update:value', { sellers });
const sellerCount = computed(() => props.value.sellers?.length || '');
const sellerCountOptions = computed(() =>
  Array.from({ length: props.catalog.sellers?.length || 0 }, (_, index) =>
    String(index + 1)
  )
);
const annotationTypes = computed(() =>
  (props.catalog.annotation_types || []).filter(
    type => !['construcao', 'logradouro'].includes(type.id)
  )
);
const updateSellerCount = value => {
  const count = Number(value);
  const current = props.value.sellers || [];
  update(
    Array.from(
      { length: count },
      (_, index) => current[index] || { seller_id: '', annotation_type_ids: [] }
    )
  );
};
const updateSeller = (index, field, fieldValue) =>
  update(
    props.value.sellers.map((seller, sellerIndex) =>
      sellerIndex === index ? { ...seller, [field]: fieldValue } : seller
    )
  );
</script>

<template>
  <div class="grid gap-4">
    <h3 class="font-semibold text-lais-text">
      {{ t('POST_SALE.TOPICS.ANNOTATION.TITLE') }}
    </h3>
    <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
      {{ t('POST_SALE.TOPICS.ANNOTATION.QUANTITY') }}
      <select
        :value="sellerCount"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-2 font-normal"
        @change="updateSellerCount($event.target.value)"
      >
        <option value="">{{ t('POST_SALE.TOPICS.COMMON.SELECT') }}</option>
        <option v-for="count in sellerCountOptions" :key="count" :value="count">
          {{ count }}
        </option>
      </select>
    </label>
    <div
      v-for="(seller, index) in value.sellers || []"
      :key="index"
      class="grid gap-3 rounded-lais border border-lais-border-soft p-4"
    >
      <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
        {{ t('POST_SALE.TOPICS.ANNOTATION.SELLER') }}
        <select
          :value="seller.seller_id"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-2 font-normal"
          @change="updateSeller(index, 'seller_id', $event.target.value)"
        >
          <option value="">{{ t('POST_SALE.TOPICS.COMMON.SELECT') }}</option>
          <option
            v-for="option in catalog.sellers || []"
            :key="option.id"
            :value="option.id"
          >
            {{ option.name }}
          </option>
        </select>
      </label>
      <fieldset class="grid gap-2">
        <legend class="text-sm font-semibold text-lais-text-body">
          {{ t('POST_SALE.TOPICS.ANNOTATION.TYPES') }}
        </legend>
        <label
          v-for="option in annotationTypes"
          :key="option.id"
          class="flex items-center gap-2 text-sm text-lais-text-body"
        >
          <input
            type="checkbox"
            :checked="seller.annotation_type_ids?.includes(option.id)"
            @change="
              updateSeller(
                index,
                'annotation_type_ids',
                $event.target.checked
                  ? [...(seller.annotation_type_ids || []), option.id]
                  : (seller.annotation_type_ids || []).filter(
                      id => id !== option.id
                    )
              )
            "
          />
          {{ option.label }}
        </label>
      </fieldset>
    </div>
  </div>
</template>
